// extracted by mini-css-extract-plugin
export default {"bannerSection":"Hero_bannerSection__eII6s","content":"Hero_content__YX6au"};